const PO_STATUS_COLOR: Record<string, string> = {
  Draft: "#888",
  PendingApproval: "#7c3aed",
  Approved: "#0891b2",
  Sent: "#4f46e5",
  Acknowledged: "#2f9e44",
  Received: "#087f5b",
  Cancelled: "#c92a2a",
};

export function POStatusBadge({ s }: { s: string }) {
  const c = PO_STATUS_COLOR[s] ?? "#888";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: c + "22",
        color: c,
        border: `1px solid ${c}44`,
      }}
    >
      {s}
    </span>
  );
}
